import { ApiResponse, makeApiCall } from "./index";

const BASE_URL = process.env.REACT_APP_API_VEHICLE_CONTRACT_URL;

// GET request
export function getVehicleContracts(filters?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}vehicle-contracts`, "GET", filters);
}

// POST request
export function addVehicleContract(
  action: string,
  body?: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}vehicle-contracts?action=${action}`,
    "POST",
    body,
  );
}

// PUT request
export function updateVehicleContract(
  contractId: number,
  action: string,
  body?: any,
): Promise<ApiResponse> {
  return makeApiCall(
    action
      ? `${BASE_URL}vehicle-contracts/${contractId}?action=${action}`
      : `${BASE_URL}vehicle-contracts/${contractId}`,
    "PUT",
    body,
  );
}

// DELETE request
export function deleteVehicleContract(
  contractId: number,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}vehicle-contracts/${contractId}`, "DELETE");
}

// PATCH request
export function restoreVehicleContract(
  contractId: number,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}vehicle-contracts/${contractId}`, "PATCH");
}

// GET request
export function getVehicleContract(
  contractId: number,
  displayCurrency?: string,
): Promise<ApiResponse> {
  const query = displayCurrency ? `?displayCurrency=${displayCurrency}` : "";
  return makeApiCall(
    `${BASE_URL}vehicle-contracts/${contractId}${query}`,
    "GET",
  );
}

// GET request
export function getVehicleContractHtml(
  contractId: string,
  param: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}vehicle-contracts/${contractId}/contractHtml`,
    "GET",
    param,
  );
}

// GET request
export function GetContractTemplate(contractId: number): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}vehicle-contracts/${contractId}/contractTemplate`,
    "GET",
  );
}

// GET request
export function GetDamageTemplate(contractId: number): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}vehicle-contracts/${contractId}/damageTemplate`,
    "GET",
  );
}

// GET request
export function GetSignEmailTemplate(contractId: string): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}vehicle-contracts/${contractId}/eSignTemplate`,
    "GET",
  );
}

// GET request
export function sendEmail(id: number, body: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}vehicle-contracts/email`, "POST", body);
}

// GET clients/vehicle-contracts/{contractId}/sms-preview?smsType= -> { body: string }
// Renders the contract's SMS template against real contract/customer/vehicle data.
export function getContractSmsPreview(
  contractId: number,
  smsType: number,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}vehicle-contracts/${contractId}/sms-preview`,
    "GET",
    { smsType },
  );
}

// POST vehicle-contracts/sms -> { success: boolean }
// body.body is used as-is if supplied (user-edited preview), otherwise re-rendered server-side.
export function sendContractSms(body: {
  referenceId: number;
  smsType: number;
  to: string[];
  body?: string;
}): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}vehicle-contracts/sms`, "POST", body);
}

// GET request
export function addVehicleContractSignature(
  contractId: string,
  body: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}vehicle-contracts/${contractId}/contractSignature`,
    "POST",
    body,
  );
}

// Delete signatures request
export function deleteVehicleContractSignature(
  contractId: string,
  params: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}vehicle-contracts/${contractId}/contractSignature`,
    "DELETE",
    params,
  );
}

//get calculation
export function getVehicleContractPrice(filters?: any): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}vehicle-contracts/calculatePricing`,
    "POST",
    filters,
  );
}

//get available vehicles
export function getAvalilableVehiclesRent(filters?: any): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}vehicle-contracts/availableVehicles`,
    "GET",
    filters,
  );
}

//get available types
export function getAvalilableVehicleTypesRent(
  filters?: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}vehicle-contracts/availableVehicleTypes`,
    "GET",
    filters,
  );
}

//get available actions for current state
export function getAvailableContractActions(
  contractId: number,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}vehicle-contracts/${contractId}/states`,
    "GET",
  );
}

export function getAllContractWorkflowStatuses(
  workflowId?: number,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/workflowStatuses`, "GET", {
    workflowId,
  });
}

//get pdf of the contract
export function getContractPdf(
  contractId: number,
  path?: string,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}vehicle-contracts/${contractId}/contractPDF`,
    "GET",
    { path: path },
  );
}

export function getAllContractNotes(contractId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/${contractId}/notes`, "GET");
}

// POST request
export function addContractNote(
  contractId: number,
  body?: any,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/${contractId}/notes`, "POST", body);
}

// PUT request
export function updateContractNote(
  bookingNoteId: number,
  body?: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/notes/${bookingNoteId}`,
    "PUT",
    body,
  );
}

// DELETE request
export function deleteContractNote(
  bookingNoteId: number,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/notes/${bookingNoteId}`, "DELETE");
}

// PATCH request
export function restoreContractNote(
  bookingNoteId: number,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/notes/${bookingNoteId}`, "PATCH");
}

// GET request
export function getContractNoteById(
  bookingNoteId: number,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/notes/${bookingNoteId}`, "GET");
}

export function getContractPayments(
  contractId: number,
  filters?: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/${contractId}/payments`,
    "GET",
    filters,
  );
}

export function getContractPaymentsSummary(
  contractId: number,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/${contractId}/payments/summary`,
    "GET",
  );
}

export function getContractPaymentPdf(paymentId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/payments/${paymentId}/pdf`, "GET");
}

export function getPaymentEmailTemplate(
  paymentId: number,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/payments/${paymentId}/email`, "GET");
}

export function sendPaymentEmail(
  paymentId: number,
  body: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/payments/${paymentId}/email`,
    "POST",
    body,
  );
}

// POST request
export function addContractPayment(
  contractId: number,
  body?: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/${contractId}/payments`,
    "POST",
    body,
  );
}

// GET request
export function getContractPaymentById(
  PaymentId: number,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/payments/${PaymentId}`, "GET");
}

export function getContractDocuments(contractId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/${contractId}/documents`, "GET");
}

export function uploadContractDocuments(
  contractId: number,
  body: FormData,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/${contractId}/documents`,
    "POST",
    body,
  );
}

export function getContractDocument(
  contractId: number,
  fileId: number,
  queryParams?: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/${contractId}/documents/${fileId}`,
    "GET",
    queryParams,
  );
}

export function deleteContractDocument(
  contractId: number,
  fileId: number,
  queryParams?: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/${contractId}/documents/${fileId}`,
    "DELETE",
    queryParams,
  );
}

export function getContractAdditionalDrivers(
  contractId: number,
  filters?: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/${contractId}/additionalDrivers`,
    "GET",
    filters,
  );
}

export function addContractAdditionalDriver(
  contractId: number,
  body?: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/${contractId}/additionalDrivers`,
    "POST",
    body,
  );
}

export function getContractAdditionalDriverById(
  id: number,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/additionalDrivers/${id}`, "GET");
}

export function deleteContractAdditionalDriver(
  id: number,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/additionalDrivers/${id}`, "DELETE");
}

export function updateContractAdditionalDriver(
  driverId: number,
  body?: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/additionalDrivers/${driverId}`,
    "PUT",
    body,
  );
}

export function getAdditionalDriverDocuments(
  additionalDriverId: number,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/additionalDrivers/${additionalDriverId}/documents`,
    "GET",
  );
}

export function uploadAdditionalDriverDocuments(
  additionalDriverId: number,
  body: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/additionalDrivers/${additionalDriverId}/documents`,
    "POST",
    body,
  );
}

export function deleteAdditionalDriverDocument(
  additionalDriverId: number,
  fileId: string,
  queryParams: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/additionalDrivers/${additionalDriverId}/documents/${fileId}`,
    "DELETE",
    queryParams,
  );
}

export function GetAdditionalDriverDocument(
  additionalDriverId: number,
  fileId: number,
  queryParams?: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/additionalDrivers/${additionalDriverId}/documents/${fileId}`,
    "GET",
    queryParams,
  );
}

/**********************Start Vehicle Exchange Api's**************************/
// GET request
export function getVehicleExchanges(contractId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/${contractId}/exchanges`, "GET");
}

// Post request
export function createVehicleExchange(
  contractId: number,
  body: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/${contractId}/exchanges`,
    "POST",
    body,
  );
}

// GET request
export function getVehicleExchange(
  vehicleExchangeId: number,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/exchanges/${vehicleExchangeId}`,
    "GET",
  );
}

// PUT request
export function updateVehicleExchange(
  vehicleExchangeId: number,
  body: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/exchanges/${vehicleExchangeId}`,
    "PUT",
    body,
  );
}
/**********************End Vehicle Exchange Api's**************************/

// GET request
export function GetAndCheckContractCode(
  existingCode: string,
  id: number | null,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}vehicle-contracts/code`, "POST", {
    existingCode: existingCode,
    entityType: "CONTRACT",
    primaryKeyValue: id,
  });
}

/********************** Start Invoice Api's**************************/

// GET request
export function GenerateContractInvoice(
  contractId: string,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}vehicle-contracts/${contractId}/invoice`,
    "GET",
  );
}

export function GenerateContractSplitInvoice(
  contractId: string,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}vehicle-contracts/${contractId}/invoice/split`,
    "GET",
  );
}

/********************** End Invoice Api's**************************/
/********************Traffic Ticket********************************/
// GET request
export function getTrafficTickets(contractId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/${contractId}/tickets`, "GET");
}

// Post request
export function createTrafficTicket(body: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/tickets`, "POST", body);
}

// GET request
export function getTrafficTicketById(contractId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/${contractId}/tickets`, "GET");
}

// PUT request
export function updateTrafficTicket(
  id: number,
  body: any,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/tickets/${id}`, "PUT", body);
}

// DELETE request
export function deleteTrafficTicket(id: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/tickets/${id}`, "DELETE");
}

export function getTrafficTicketDocuments(
  trafficTicketId: number,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/tickets/${trafficTicketId}/documents`,
    "GET",
  );
}

export function uploadTrafficTicketDocuments(
  trafficTicketId: number,
  body: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/tickets/${trafficTicketId}/documents`,
    "POST",
    body,
  );
}

export function deleteTrafficTicketDocument(
  trafficTicketId: number,
  fileId: string,
  queryParams: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/tickets/${trafficTicketId}/documents/${fileId}`,
    "DELETE",
    queryParams,
  );
}

export function GetTrafficTicketDocument(
  trafficTicketId: number,
  fileId: number,
  queryParams?: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/tickets/${trafficTicketId}/documents/${fileId}`,
    "GET",
    queryParams,
  );
}

// GET request
export function GetTicketPdf(trafficTicketId: number): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/tickets/${trafficTicketId}/ticketPdf`,
    "GET",
  );
}

// GET request
export function GetTicketEmailTemplate(
  trafficTicketId: number,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/tickets/${trafficTicketId}/ticketTemplate`,
    "GET",
  );
}

// GET request
export function sendTicketEmail(id: number, body: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/tickets/email`, "POST", body);
}

/********************Offense Types********************************/
// GET request
export function getOffenseTypes(): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/offenseTypes`, "GET");
}

// Post request
export function createOffenseTypes(body: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/offenseTypes`, "POST", body);
}

// PUT request
export function updateOffenseTypes(
  id: number,
  body: any,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/offenseTypes/${id}`, "PUT", body);
}
export function deleteOffense(id: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/offense/${id}`, "DELETE");
}
/***************Contract billing, inusance and claim **************/
// GET request billings of contract
export function getBillings(contractId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/${contractId}/billings`, "GET");
}

// GET request insurance of contract
export function getInsurance(
  contractId: number,
  displayCurrency?: string,
): Promise<ApiResponse> {
  const query = displayCurrency ? `?displayCurrency=${displayCurrency}` : "";
  return makeApiCall(
    `${BASE_URL}contracts/${contractId}/insurance${query}`,
    "GET",
  );
}

export function getContractInsuranceDocuments(
  contractId: number,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/${contractId}/insurance/documents`,
    "GET",
  );
}

export function addContractInsuranceDocuments(
  contractId: number,
  body: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/${contractId}/insurance/documents`,
    "POST",
    body,
  );
}

export function GetContractInsuranceDocument(
  contractId: number,
  fileId: number,
  queryParams?: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/${contractId}/insurance/documents/${fileId}`,
    "GET",
    queryParams,
  );
}

export function DeleteContractInsuranceDocument(
  contractId: number,
  fileId: number,
  queryParams?: any,
) {
  return makeApiCall(
    `${BASE_URL}contracts/${contractId}/insurance/documents/${fileId}`,
    "DELETE",
    queryParams,
  );
}

// GET request claim of contract
export function getClaim(
  contractId: number,
  displayCurrency?: string,
): Promise<ApiResponse> {
  const query = displayCurrency ? `?displayCurrency=${displayCurrency}` : "";
  return makeApiCall(`${BASE_URL}contracts/${contractId}/claim${query}`, "GET");
}
/******************************************************************/

// GET request airport info of contract
export function getContractAirportInfo(
  contractId: number,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}contracts/${contractId}/airportinfo`, "GET");
}

export function updateContractPaymentStatus(
  paymentId: number,
  status: number,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/payments/${paymentId}/status`,
    "PUT",
    { status },
  );
}

// Add this function alongside getContractPaymentById, addContractPayment
export function editContractPayment(
  paymentId: number,
  body?: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/payments/${paymentId}/edit`,
    "PUT",
    body,
  );
}

export function refundContractPayment(
  paymentId: number,
  body: { refundAmount: number; refundDate: string; reason?: string },
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/payments/${paymentId}/refund`,
    "POST",
    body,
  );
}

export function releaseContractDeposit(
  paymentId: number,
  body: { reason?: string },
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}contracts/payments/${paymentId}/release-deposit`,
    "POST",
    body,
  );
}

// ── PayPal Standard Checkout ──────────────────────────────────────────────────

export function createContractPayPalOrder(body: {
  contractId: number;
  amount: number;
  transactionType: string;
  paymentMode: string;
  returnUrl: string;
  cancelUrl: string;
}): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}api/paypal-checkout/create-order`,
    "POST",
    body,
  );
}

export function completeContractPayPalOrder(body: {
  orderId: string;
  contractId: number;
  amount: number;
  transactionType: string;
  paymentMode: string;
  paymentMethod?: string;
}): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}api/paypal-checkout/complete-order`,
    "POST",
    body,
  );
}

export function captureContractPayPalAuthorization(body: {
  contractId: number;
  paymentId: number;
  authorizationId: string;
  amount: number;
  paymentMethod?: string;
}): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}api/paypal-checkout/capture`, "POST", body);
}

export function voidContractPayPalAuthorization(body: {
  contractId: number;
  authorizationId: string;
  paymentId?: number;
}): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}api/paypal-checkout/void`, "POST", body);
}

export function refundContractPayPal(body: {
  contractId: number;
  paymentId: number;
  captureId: string;
  transactionType: "Refund" | "PartialRefund";
  amount: number;
  paymentMethod?: string;
}): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}api/paypal-checkout/refund`, "POST", body);
}

export function createContractMipsPaymentRequest(body: {
  contractId: number;
  totalAmount: number;
  totalTax?: number;
  referenceId?: string;
  description?: string;
  currencyCode?: string;
  requestMode?: string;
  sendingMode?: string;
  options?: string;
  expiryDate?: string | Date | null;
  customRedirectionUrl?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  maxAmountTotal?: number | null;
  maxAmountPerClaim?: number | null;
  maxFrequency?: number | null;
  maxDate?: string | Date | null;
  depositAmount?: number | null;
  clientAccountNumber?: string;
  clientOtherData?: any[];
  orderOtherData?: any[];
  balancePattern?: any[];
  membership?: any;
}): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}api/mips-checkout/create-payment-request`,
    "POST",
    body,
  );
}
export function completeContractMipsOrder(body: {
  contractId: number;
  amount: number;
  paymentMethod?: string;
  paymentMode?: string;
  transactionType?: string;
  orderId?: string;
  requestId?: string;
  salt?: string;
  cipherKey?: string;
  receivedCryptedData?: string;
}): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}api/mips-checkout/complete-order`,
    "POST",
    body,
  );
}
export function releaseContractMipsPayment(body: {
  contractId: number;
  transactionId: string;
  amount: number;
  currencyCode?: string;
}): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}api/mips-checkout/release`, "POST", body);
}

export function voidContractMipsPayment(body: {
  contractId: number;
  transactionId: string;
  reason?: string;
}): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}api/mips-checkout/void`, "POST", body);
}

export function refundContractMipsPayment(body: {
  contractId: number;
  transactionId: string;
  amount: number;
  currencyCode?: string;
  reason?: string;
}): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}api/mips-checkout/refund`, "POST", body);
}

export function deleteContractReferral(
  contractId: number,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}vehicle-contracts/${contractId}/referral`,
    "DELETE",
  );
}
